import { createStore } from "vuex";

const store = createStore({
  state: {
    list: {
      test: "test",
    },
    logo: "logo-tink.svg",
    color: "btn-primary",
    store: "DE1",
  },
  getters: {
    _list: (state) => state.list,
    _logo: (state) => state.logo,
    _color: (state) => state.color,
    _store: (state) => state.store
  },
  mutations: {
    add: (state, payload) => {
      state.list = payload;
    },
    remove: (state, price) => {
      state.list = state.list.filter((item) => item.id !== price.id);
      state.list = state.list.slice(-1);
    },
    changeLogo: (state, payload) => {
      console.log("logo set:", payload);
      state.logo = payload;
    },
    changeColor: (state, payload) => {
      console.log("color set:", payload);
      state.color = payload;
    },
    changeStore: (state, payload) => {
      console.log("store set:", payload);
      state.store = payload;
    }
  },
});

export default store;
